
import { scaleLinear, scaleTime, timeFormat, extent } from 'd3';
import { useData } from './useData';
import { AxisBottom } from './AxisBottom';
import { AxisLeft } from './AxisLeft';
import { Marks } from './Marks';
import WaitingIndicator from '../../../../general-ui/waiting-indicator/waiting-indicator';
// const width = 808;
// const height = 300;
const margin = { top: 16, right: 16, bottom: 30, left: 56 };
// const xAxisLabelOffset = 50;
// const yAxisLabelOffset = 45;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const SessionTimeline = ({ width, height, dataIn, loading, error }) => {

	if (error) {
		return <div className="retention-chart-loading">{error}</div>;
	}

	if (loading) {
		return <div className="retention-chart-loading"><WaitingIndicator /></div>;
	}

	if (!dataIn?.length) {
		return <div className="retention-chart-loading">No data to display</div>;
	}

	const data = useData(dataIn = { dataIn });

	const innerHeight = height - margin.top - margin.bottom;
	const innerWidth = width - margin.left - margin.right;

	const xValue = d => d.timestamp;
	// const xAxisLabel = 'Time';

	const yValue = d => d.count;
	// const yAxisLabel = 'Count';

	const xAxisTickFormat = timeFormat('%a %I:%M');

	const xScale = scaleTime()
		.domain(extent(data, xValue))
		.range([0, innerWidth])
		.nice();

	const yScale = scaleLinear()
		.domain(extent(data, yValue))
		.range([innerHeight, 0])
		.nice();

	return (

		<svg width={width} height={height}>
			<g transform={`translate(${ margin.left },${ margin.top })`}>
				<AxisBottom
					xScale={xScale}
					innerHeight={innerHeight}
					tickFormat={xAxisTickFormat}
					tickOffset={7}
				/>
				<AxisLeft yScale={yScale} innerWidth={innerWidth} tickOffset={7} />
				<Marks
					data={data}
					xScale={xScale}
					yScale={yScale}
					xValue={xValue}
					yValue={yValue}
					tooltipFormat={xAxisTickFormat}
					circleRadius={1}
					innerHeight={innerHeight}
				/>
			</g>
		</svg>


	);
};

export default SessionTimeline;
